import  { useState } from 'react';
import { useAuthContext } from './adminAuthHook'
import { getAllAgencies } from '../redux/reducers/agenciesSlice'
import { useDispatch } from 'react-redux';

export default function AgenciesHook() {
    const dispatch = useDispatch()
    const [profile, setProfile] = useState('')

    const apiUrl = process.env.REACT_APP_API_URL;
    const { admin } = useAuthContext()
    const getAgencies=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/admin/agencies/get`,{
          headers:{
            'Authorization': `Bearer ${admin.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllAgencies(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }


    const getAgencyDetails=async(id)=>{
      debugger
      try {
       const response=await fetch(`${apiUrl}/api/admin/agencies/get/profile`,{
        method:'POST',
         headers:{
           'Authorization': `Bearer ${admin.token}`,
           'Content-Type': 'application/json',
         },
         body:JSON.stringify({id})
       })
       
       const json=await response.json()
       if(response.ok){ 
        setProfile(json.data)
       }
       
      } catch (error) {
      console.log('error',error)
      }
   }
  return {getAgencies,getAgencyDetails,profile}
}
